<!--
 * @Description: 对比地图
 * @Date: 2022-11-02 16:17:47
-->
<template>
  <el-dialog
    center
    title="地图对比"
    top="7vh"
    width="68vw"
    :visible="true"
    :before-close="closeDialog"
    :custom-class="{ main__detail: !!isDetail }"
  >
    <div class="main">
      <div class="left">
        <div v-if="detail.customerName" class="item__txt">
          <h1>目标名称：</h1>
          <el-tooltip
            popper-class="main__tooltip"
            effect="dark"
            :content="detail.customerName"
            placement="top-start"
          >
            <p
              style="cursor: pointer;"
              @click="onCopyClick(detail.customerName)"
            >
              <span>
                {{
                  detail.customerName && detail.customerName.length > 81
                    ? detail.customerName.slice(0, 81) + '…'
                    : detail.customerName
                }}
              </span>
              <i class="el-icon-copy-document"></i>
            </p>
          </el-tooltip>
        </div>
        <div v-if="detail.visitAddress" class="item__txt">
          <h1>目标地址：</h1>
          <el-tooltip
            popper-class="main__tooltip"
            effect="dark"
            :content="detail.visitAddress"
            placement="top-start"
          >
            <p
              style="cursor: pointer;"
              @click="onCopyClick(detail.visitAddress)"
            >
              <span>
                {{
                  detail.visitAddress && detail.visitAddress.length > 81
                    ? detail.visitAddress.slice(0, 81) + '…'
                    : detail.visitAddress
                }}
              </span>
              <i class="el-icon-copy-document"></i>
            </p>
          </el-tooltip>
        </div>
        <div v-if="detail.ssq" class="item__txt">
          <h1>省市区：</h1>
          <el-tooltip
            popper-class="main__tooltip"
            effect="dark"
            :content="detail.ssq"
            placement="top-start"
          >
            <p style="cursor: pointer;" @click="onCopyClick(detail.ssq)">
              <span>
                {{
                  detail.ssq && detail.ssq.length > 81
                    ? detail.ssq.slice(0, 81) + '…'
                    : detail.ssq
                }}
              </span>
              <i class="el-icon-copy-document"></i>
            </p>
          </el-tooltip>
        </div>
        <div class="item__img">
          <h1>任务提交原图：</h1>
          <div>
            <el-image
              fit="contain"
              :src="detail.addressPicUrl"
              :preview-src-list="[detail.addressPicUrl]"
            ></el-image>
          </div>
        </div>
      </div>
      <div class="stick"></div>
      <div class="right">
        <div style="margin-bottom:15px">
          <el-autocomplete
            style="width:80%"
            v-model="address"
            :fetch-suggestions="querySearch"
            ref="addrselect"
            @select="handleSelect"
          ></el-autocomplete>
          <el-button @click="search" type="primary">搜索</el-button>
        </div>
        <h1>地图信息：</h1>
        <div class="map__container" id="diff-map-container"></div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { Task } from '@R/api/index';
import { mapState } from 'vuex';
import jsonp from 'jsonp';
import config from '@/config';
const qq = Reflect.get(window, 'qq');
import { copyText } from '@/tools';
const mapSuggestion = keyword => {
  return new Promise(resolve => {
    try {
      jsonp(
        `//apis.map.qq.com/ws/place/v1/suggestion?keyword=${keyword}&output=jsonp&page_size=20&page_index=1&key=${config.QQ_MAP_KEY}`,
        null,
        (err, data) => {
          if (err) {
            console.log(err);
          } else {
            resolve(data.data);
          }
        }
      );
    } catch (error) {
      console.log(error);
      resolve([]);
    }
  });
};
export default {
  name: 'diff-map',
  props: ['projectId', 'row', 'isDetail'],
  data() {
    return {
      address: '',
      detail: {
        customerName: '',
        visitAddress: '',
        ssq: '',
        addressPicUrl: '',
        visitLongitude: '',
        visitLatitude: ''
      }
    };
  },
  computed: {
    ...mapState('dataAnalysis', ['task']),
    isQuickAuditList() {
      return ['taskCheckLog', 'taskQuickAuditList'].includes(this.$route.name);
    }
  },
  methods: {
    onCopyClick(str) {
      copyText(str);
    },
    handleSelect(item) {
      //经度
      this.detail.visitLongitude = item.address.lng;
      //纬度
      this.detail.visitLatitude = item.address.lat;
    },
    querySearch(queryString, cb) {
      if (!this.address) {
        cb([]);
        return;
      }
      mapSuggestion(this.address).then(res => {
        let resList = res.map(item => {
          return {
            value: item.title + `(${item.address})`,
            address: item.location
          };
        });
        cb(resList);
      });
    },
    search() {
      this.initMap();
    },
    closeDialog() {
      // 防止esc按键关闭 图片放大时关闭弹层
      const ImgEl = document.getElementsByClassName(
        'el-image-viewer__wrapper'
      )[1];
      if (!ImgEl) {
        this.$emit('close');
      }
    },
    initMap() {
      const lat = this.detail.visitLatitude;
      const lng = this.detail.visitLongitude;
      const options = {
        zoom: 17,
        pitchable: false,
        rotatable: false,
        disableDefaultUI: true,
        mapTypeId: qq.maps.MapTypeId.ROADMAP
      };
      options['center'] = new qq.maps.LatLng(lat, lng);
      this.map = new qq.maps.Map(
        document.getElementById('diff-map-container'),
        options
      );
      this.marker = new qq.maps.Marker({
        animation: null,
        position: new qq.maps.LatLng(lat, lng),
        map: this.map
      });
    }
  },
  async created() {
    let dataState = '0';
    // 如果是任务记录进的此定位对比则把列表搜索条件的结算状态带进去
    // 快捷审核&审核记录默认全是未结算则默认dataState为0
    if (!this.isQuickAuditList) {
      dataState = this.task.tableDataRespondQuery.dataState;
    }
    const { pdata } = await Task.locationMapComparison({
      projectId: this.projectId,
      taskId: this.row.taskId,
      dataState
    });
    this.detail = {
      ...(this.detail || {}),
      ...(pdata || {})
    };
    this.$nextTick(() => {
      this.initMap();
    });
  }
};
</script>
<style lang="scss">
.main__detail {
  margin-left: 1vw !important;
}
.main__tooltip {
  max-width: 50vw !important;
}
</style>
<style lang="scss" scoped>
.main {
  display: flex;
  flex-wrap: nowrap;
  align-content: center;
  align-items: center;

  width: 100%;
  font-size: 16px;
  height: 65vh;
  .left {
    width: 50%;
    height: 100%;

    .item__txt {
      display: flex;
      margin-top: 10px;
      h1 {
        min-width: 140px;
      }
      p {
        max-width: 566px;
        margin-right: 20px;
      }
    }
    .item__img {
      margin-top: 15px;
      div {
        background: #f2f2f2;
        width: 98%;
        height: 35vh;
        text-align: center;
      }
      h1 {
        margin-bottom: 15px;
        width: 140px;
      }
    }
  }
  .stick {
    width: 1px;
    height: 90%;
    background: #000;
  }
  .right {
    padding-left: 20px;
    width: 50%;
    height: 100%;
    // padding-top: 80px;
    .map__container {
      margin-top: 10px;
      width: 98%;
      height: 50vh;
    }
  }
}
</style>
